/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

const THUMBNAIL_FILE_FIELD = "thumbnailFile"
const METADATA_FIELD = "metadata"
const IMAGE_METADATA_FIELD = "image"

export function prepareQwoachFileNormalWritePayload(qwoachFile, options = {}) {
	let dbJson = qwoachFile.asJsonObject()
	removeGeneratedFields(dbJson)
	if(options.methodType === "update"){
		dbJson = createUpdatePayload(dbJson)
	}
	return dbJson
}

function removeGeneratedFields(dbJson) {
	delete dbJson[THUMBNAIL_FILE_FIELD]
	removeGeneratedMetadataFields(dbJson)
}

function removeGeneratedMetadataFields(dbJson) {
	let metadata = dbJson[METADATA_FIELD]
	if(metadata){
		delete metadata[IMAGE_METADATA_FIELD]
		if(Object.keys(metadata).length === 0){
			delete dbJson[METADATA_FIELD]
		}
	}
}

function createUpdatePayload(dbJson) {
	let updatePayload = {...dbJson}
	applyMetadataDotPaths(updatePayload)
	return updatePayload
}

function applyMetadataDotPaths(updatePayload) {
	let metadata = updatePayload[METADATA_FIELD]
	if(metadata){
		delete updatePayload[METADATA_FIELD]
		flattenObject(metadata, METADATA_FIELD, updatePayload)
	}
}

function flattenObject(object, pathPrefix, output) {
	let keys = Object.keys(object)
	if(keys.length === 0){
		output[pathPrefix] = object
	}
	for(let key of keys) {
		let value = object[key]
		let path = `${pathPrefix}.${key}`
		if(shouldFlattenValue(value)){
			flattenObject(value, path, output)
		} else {
			output[path] = value
		}
	}
}

function shouldFlattenValue(value) {
	return !!value && Object.getPrototypeOf(value) === Object.prototype
}
